import { render, staticRenderFns } from "./ProductAmountToBeOrderedFilter.vue?vue&type=template&id=bc1721d8"
import script from "./ProductAmountToBeOrderedFilter.vue?vue&type=script&lang=ts"
export * from "./ProductAmountToBeOrderedFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports